(function() { window.GUID_da23828e_e1df_41ec_b0dc_d2af78b48c32 = { getGuid: function() { return "da23828e-e1df-41ec-b0dc-d2af78b48c32"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        var VideoPlayerInternals;
        (function (VideoPlayerInternals) {
            class Elements {
                constructor(player) {
                    this.player = player;
                    this.timeDisplay = {
                        totalIsMoreThanOneHour: false,
                        container: null,
                        cursor: null,
                        total: null
                    };
                    this.progressContainer = player.$Control.find('.progress-container');
                    this.progressThumb = this.progressContainer.find('.progress-thumb');
                    this.buttons = player.buttons;
                    this.video = player.video;
                    this.controls = player.controls;
                    this.timeDisplay.container = player.$Control.find('.time-display');
                    this.timeDisplay.cursor = this.timeDisplay.container.find('.time-cursor');
                    this.timeDisplay.total = this.timeDisplay.container.find('.time-total');
                }
            }
            VideoPlayerInternals.Elements = Elements;
        })(VideoPlayerInternals = Controls.VideoPlayerInternals || (Controls.VideoPlayerInternals = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=VideoPlayer.Elements.pre.js.map
